
import type { PropType, SetupContext } from 'vue'
import { defineComponent, ref } from 'vue'
import { PositionEnum } from '../enums'
import { EpbButton } from './shared/epb-button'

export default defineComponent({
  name: 'EpbAside',
  components: {
    EpbButton,
  },
  props: {
    closable: Boolean,
    scrollable: {
      type: Boolean,
      default: true,
    },
    collapsible: Boolean,
    collapseText: String,
    orientation: {
      type: String as PropType<PositionEnum>,
      default: PositionEnum.RIGHT,
    },
    collapsed: Boolean,
    fullscreen: Boolean,
  },
  setup(props, { emit }: SetupContext) {
    const asideWrapper = ref(null)

    function onClick(event): void {
      const asideWrapperClicked = event.target === asideWrapper.value
      // Close aside when clicking outside
      if (props.fullscreen && asideWrapperClicked) {
        emit('close')
      }
    }

    return { asideWrapper, onClick }
  },
  data() {
    return {
      PositionEnum,
    }
  },
  computed: {
    hasText(): boolean {
      return !!this.collapseText
    },
    expanded(): boolean {
      return !this.collapsible || !this.collapsed
    },
    buttonProps(): Record<string, any> {
      return {
        type: 'void',
        color: 'default',
      }
    },
  },
})
